const addServiceEditActions = {
  ADD_SERVICE_EDIT_INIT: 'ADD_SERVICE_EDIT_INIT',
  ADD_SERVICE_EDIT_SET: 'ADD_SERVICE_EDIT_SET',
  ADD_SERVICE_PROP_SET: 'ADD_SERVICE_PROP_SET'
};
export default addServiceEditActions;
